module.exports = __webpack_public_path__ + "static/img/14.9993679.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/14.jpg
// module id = 7DVn
// module chunks = 1